import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('product'),
  products_all: []
}

const getters = {
  ...restful.getters('product'),
  products_all: (state) => state.products_all
}

const actions = {
  ...restful.actions('products'),
  async destroy_all ({ commit }, id) {
    Spin.show()
    await axios.post(`products/destroy_all`)
    Spin.hide()
    Message.success('已全部删除成功!')
    const res = await axios.get('products')
    commit('products', res.data)
  },
  async index_all ({ commit }, params) {
    const response = await axios.get('products', { params })
    commit('products_all', response.data)
  }
}

const mutations = {
  ...restful.mutations('product'),
  products (state, products) {
    state.products = products
  },
  products_all (state, products_all) {
    state.products_all = products_all
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
